export default {
  namespaced: true,
  state: {
    token: '',
    userId: ''
  },
  mutations: {
    changeToken (state, val) {
      state.token = val
    },
    changeUserId (state, val) {
      state.userId = val
    }
  }
}
